import { FC } from "react";
import { Link, useParams } from "react-router-dom";
import { ReactComponent as ResultDataIcon } from "images/resultDataIcon.svg";
import { ReactComponent as DocumentIcon } from "images/documentIcon.svg";
import { convertDate } from "helpers";
import cn from "classnames";
import styles from "./StatusOkii.module.sass";
import { OrganizationObjectStatusResponse } from "libs/apiClient/data-contracts";

interface RowProps {
	row: OrganizationObjectStatusResponse;
}

const Row: FC<RowProps> = ({ row }) => {
	const { organizationId } = useParams();

	return (
		<div className={styles.bodyRow}>
			<Link
				className={cn("link", styles.linkName)}
				to={`/categorization/organizations/${row.id}/steps/2.2`}
				state={{ id: row.id, name: row.name }}>
				<div>
					<div
						className={cn(styles.circle, {
							[styles.green]: row.status === "COMPLETE",
							[styles.orange]: row.status === "IN_PROGRESS",
							[styles.white]: row.status === "NOT_STARTED",
							[styles.purple]: row.status === "REPEATED",
						})}
					/>
				</div>
				{row.name}
			</Link>
			<div>{row.fstekRegistry || "—"}</div>
			<div>{convertDate(row.plannedDate!) || "—"}</div>
			<div>{row.assignedCategory}</div>
			<div>{convertDate(row.approvedDate!) || "—"}</div>
			<div className="df">
				<Link
					className={cn(styles.rowBtn)}
					to={`/categorization/documents/${organizationId}`}
					state={{ objectName: row.name }}>
					<DocumentIcon />
					Документы
				</Link>
				<Link className={cn(styles.rowBtn)} to={`/categorization/organizations/${organizationId}/steps/7.1`}>
					<ResultDataIcon />
					Итоговые данные
				</Link>
			</div>
		</div>
	);
};

export default Row;
